module.exports = __webpack_public_path__ + "img/hp.3728e9a3.png";